module.exports = {
  insuranceLeadSourceOptions: [
    "-None-",
    "Advisor Generated",
    "Canadian LIC Website",
    "CanadianLIC Website (Critical Illness)",
    "CanadianLIC Website (Super Visa)",
    "CanadianLIC Website (Term Life)",
    "CanadianLIC Website (Whole Life)",
    "Chat",
    "Chat- Created",
    "Cold Call",
    "Email Campaign",
    "Facebook Ads",
    "Google",
    "Google AdWords",
    "Harpreet Puri Website",
    "Home Page",
    "Internal Seminar",
    "Linked In",
    "Radio",
    "Referral",
    "Social Media - Others",
    "Supervisa Insurance Canada",
    "SVIC Website (Super Visa)",
    "Trade Show",
    "Twitter",
    "Vendor Partner Seminar",
    "Walk - Ins",
    "WhatsApp - Canadian LIC",
  ],
  insuranceLeadStatusOptions: [
    "-None-",
    "Not Contacted",
    "Attempted to Contact",
    "Contact in Future",
    "Contacted & Not Interested",
    "Pre-Qualified",
    "Appointment",
    "Quoted / In Process",
    "Confirmation of Application Go Ahead by Lead - Life",
    "Confirmation of Application Go Ahead by Lead - Travel / Supervisa",
    "Confirmation of Application Go Ahead by Lead - Investments",
    "Junk Lead",
    "Lost & Listed for Future Reactivation",
    "Lost & Closed / Archived",
    "Escalated",
    "Not Qualified",
    "Discovery Call",
    "Advisor Lead",
  ],
  leadStatusStageOption: ["-None-", "Not Contacted"],
  referredByOptions: [
    "-None-",
    "Social Media",
    "Radio",
    "Google",
    "Advisor",
    "External Referral",
    "Lead/Client",
    "Mortgage/RealEstate/Accountant",
  ],
  preferredContactMethodOption: [
    "-None-",
    "Cell Phone",
    "Home Phone",
    "Work Phone",
    "Email",
    "Tex",
    "Email, Cell Phone, WhatsApp",
  ],
  preferredContactTimeOption: [
    "Weekdays - Morning",
    "Weekdays - Afternoon",
    "Weekdays - Evening",
    "Weekends - Morning",
    "Weekends - Afternoon",
    "Weekends - Evening",
    "Weekdays- Weekends- Morning",
    "Weekdays- Weekends- Evening",
    "Weekdays- Weekends- Afternoon",
    "Weekdays- Morning, Afternoon, Evening",
    "Weekends- Morning, Afternoon, Evening",
  ],
  understandingOfInsuranceOption: [
    "-None-",
    "Expert",
    "High",
    "Low",
    "Moderate",
    "Unknown",
  ],
  additionalContactInformationOption: ["-None-", "Available", "Unavailable"],
  whattypeofStudentOption: [
    "-None-",
    "International Students in Canada",
    "Canadian Students Studying Abroad",
  ],
  tripTypeOption: ["-None-", "Single Trip", "Multiple Trip"],
  objectType: ["-None-", "Yes", "No"],
  LookingForAdvisor: ["-None-", "Part Time Advisor", "Full Time Advisor"],
  frame: ["-None-", "3 Months", "6 Months", "1 Year"],
  genderOption: ["-None-", "Unknown", "Male", "Female"],
  relationShipStatusOptions: [
    "-None-",
    "Single",
    "Married",
    "Divorced",
    "Common Law",
    "Widow",
    "Widower",
  ],
  choice: ["-None-", "Unknown", "Yes", "No"],
  religionOptions: [
    "-None-",
    "Buddhism",
    "Unknown",
    "Christianity",
    "Hinduism",
    "Islam",
    "Judaism",
    "Sikhism",
    "General"
  ],
  festivalsOptions: [
    "Eid-ul-Fitr",
    "Bakr-Eid",
    "Holi",
    "Dussehra",
    "Diwali",
    "Raksha Bandhan",
    "Guru Nanak Jayanti",
    "Guru Gobind Singh Jayanti",
    "Guru Granth Sahib Prakash Divas",
    "Passover",
    "Victoria Day",
    "Family Day",
    "Mother's Day",
    "Thanksgiving",
    "Christmas",
    "New Year",
    "Lohri",
    "Vaisakhi",
    "Father's Day",
  ],
  celebratedFestivalsOptions: [
    "Canada Day",
    "New Year",
    "Family Day",
    "Victoria Day",
    "Father's Day",
    "Mother's Day",
  ],

  interactionType: ["email", "Call", "Meeting"],
  // service request forms
  lifeInsuranceOption: [
    'Term Life Insurance',
    'Term Universal Life',
    'Permanent Universal Life',
   ' Whole Life',
   ' Participating Whole Life',
    'Non Medical',
    'Permament / T100',
    'Critical Illness',
  ],
  livingBenefitsOption: [
   ' Critical Illness',
  '  Disability - Accidental',
   ' Disability - Illness',
    'Hospital Expenses',
   ' Accidental Benefits',
  ],
  servicesRequested: [
"Life Insurance",
"Auto Insurance",
"Home Insurance",
"Living Benefits",
'Health & Dental Insurance',
'Travel Insurance',
'Investments',
'Combination or Hybrid Insurance',
'Loan Protection',
'Group Insurance',
'Super Visa Insurance',
'Immigration Services',
'Business Insurance',
  ],
  businessLiabilityInsuranceOption: [
    "-None-",
    "Account Receivable Insurance",
    "Builder's Risk Insurance",
    "Business Insurance",
    "Commercial Automobile Insurance",
    "Commercial Property Insurance",
    "Contractor Insurance",
    "Corporate Insurance",
    "Cyber Liability Insurance",
    "Employee Liability Insurance",
    "Environmental Impairment Liability",
    "Garage Insurance",
    "General Liability Insurance",
    "Home Based Business Insurance",
    "Legal Expense Insurance",
    "Malpractice Insurance",
    "Private Client Insurance",
    "Product Liability Insurance",
    "Professional Liability Insurance",
    "Small Medium Business Insurance",
    "Specialty Insurance",
  ],
  immigrationServicesOption1: [
   "Super Visa",
   " Visitor Visa",
    "Work Permit",
    "Study Visa",
   " LMIA",
    "Caregivers",
    "Permanet Residence",
   " Startup Visa Program",
    "Business Visa",
   " Business Immigration - Investment",
    "Canadian Experience Class ( ECE)",
   " Citizenship",
    "Deprotation",
    "Federal Skill Worker",
 "   Temporary Resident Visa ( Business & Toursim)",
   " Provincial Nominee Program - Enterpreneur",
   " Provincial Nominee Program"
  ],
 immigrationServicesOption : [
  "Super Visa",
  "Visitor Visa",
  "Study Visa",
  "LMIA",
  "Caregivers",
  "Permanent Residence: Express Entry",
  "Startup Visa Program",
  "Business Visa",
  "Business Immigration - Investment",
  "Canadian Experience Class (ECE)",
  "Citizenship",
  "Deportation",
  "Federal Skill Worker",
  "Temporary Resident Visa (Business & Tourism)",
  "Provincial Nominee Program - Entrepreneur",
  "Provincial Nominee Program",
  "Decided",
  "PR(H&C)"
],

  travelInsuranceOption: [
    "-None-",
    "Travel",
    "Super Visa",
    "Visitor",
    "International Student",
  ],
  autoInsuranceOption: [
    "-None-",
    "Auto Insurance",
    "Bundle Insurance",
    "Boat Insurance",
    "Classic Car Insurance",
    "Private Client Insurance",
    "MotorCycle Insurance",
    "RV Insurance",
    "Snow Mobile Insurance",
    "Commercial Automobile Insurance",
  ],
  homeInsuranceOption: [
    "-None-",
    "Home Insurance",
    "Condo Insurance",
    "Tenant Insurance",
    "Cottage Insurance",
    "Rental Property Insurance",
    "Pet Insurance",
  ],
  loanProtectionOption: [
    "-None- Insurance Type",
    "Rent Insurance",
    "Mortgage Protection",
    "Loan Protection",
    "Credit Protection",
  ],
  investmentsOption: [
    "-None-",
    "Business Insurance",
    "Mutual Funds",
    "TFSA",
    "Seg Funds",
    "Annuities",
    "RRSP",
    "RRSP Loans",
    "RESP",
    "GIC",
    "Savings Account",
    "Pension Plan",
    "RIF",
    "GIA",
  ],
  groupInsuranceOption: [
    "-None-",
    "Group Life",
    "Group Disability",
    "Group Accidental Benefits",
    "Group Health & Dental",
    "Group Travel",
    "Group Eye Care",
    "Group Critical Illness",
    "Group Flexible Plan",
  ],
  // lead adviosr form
  servicesRequestedOptions: ["Life Insurance", "Living Benefits", "Health & Dental Insurance", "Travel Insurance", "Investments", "Combination or Hybrid Insurance", "Loan Protection", "Group Insurance", "Super Visa Insurance", "Business Insurance"],
  timeframeOption: ["-None-", "3 Month", "6 Month", "1 Year"],
  productCategoryOption: ["-None-", "Life", "Living Benifit", "Travel", "Health & Dental"],
  yearOption: ["2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
  dependentParentsOption: [
    { name: "Mother", ROWID: "Mother" },
    { name: "Father", ROWID: "Father" },
    { name: "Mother in Law", ROWID: "Mother in Law" },
    { name: "Father in Law", ROWID: "Father in Law" }
  ],  
  siblingsOption: [
    { name: "Brother", ROWID: "Brother" },
    { name: "Sister", ROWID: "Sister" },
    { name: "Step Brother", ROWID: "Step Brother" },
    { name: "Step Sister", ROWID: "Step Sister" }
  ],  
  dependentChildrenOption: [
    { name: "Son", ROWID: "Son" },
    { name: "Daughter", ROWID: "Daughter" },
    { name: "Step Son", ROWID: "Step Son" },
    { name: "Step Daughter", ROWID: "Step Daughter" }
  ],

  leadStatusOption: [
    "-None-",
    "Not Contacted",
    "Email",
    "Call not Answered",
    "Call Postponed by Lead",
    "Call Scheduled",
    "Lead not Contactable from paid Ads",
    "Wrong Number",
    "Appointment Sought",
    "Appointment Fixed",
    "Appointment Postponed",
    "Appointment Completed and Pending Quote Request",
    "Quoted",
    "Quoted and Response Awaited",
    "Info Shared (Travelers)",
    "Credit Card Info Pending/Provided",
    "Create Deal",
    "Undecided",
    "After 3 Months",
    "After 5 Months",
    "After 9 Months",
    "After 1 Year"
  ],
  citizenshipStatusOption: [
    "-None-",
    "Canadian Citizenship",
    "PR",
    "Work Permit",
    "Student"
  ],
  referralSourceOption: [
    "-None-",
    "Client",
    "Other than Client"
  ],
  currency: [
    "CAD",
    "USD"
  ],
  netWorth :[
    "-None-",
    "Unknown",
    "Low",
    "Moderate",
    "High"
  ],
  groupInsurance :[
"Group Life",
'Group Disability',
'Group Accidental Benefits',
'Group Health & Dental',
'Group Travel',
'Group Eye Care',
'Group Critical Illness',
'Group Flexible Plan'
  ]
};




